import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

const FormHeader = ({ children, onClose }) => {
  return (
    <Box
      sx={{
        position: "fixed",
        backgroundColor: "white",
        zIndex: 5,
        width: "inherit",
        maxWidth: "inherit",
      }}
    >
      <Box
        p={2}
        sx={{
          height: 64,
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap",
          borderBottom: 1,
          borderColor: "black",
          boxSizing: "border-box",
        }}
      >
        <Tooltip title="esc">
          <IconButton onClick={onClose}>
            <KeyboardDoubleArrowRightIcon />
          </IconButton>
        </Tooltip>
        {children}
      </Box>
    </Box>
  );
};

export const PageHeader = ({ children, onClose }) => {
  return (
    <>
      {onClose && (
        <Tooltip title="esc">
          <IconButton onClick={onClose} edge="start">
            <KeyboardDoubleArrowRightIcon />
          </IconButton>
        </Tooltip>
      )}
      {children}
    </>
  );
};

export default FormHeader;
